import React from 'react';
import { EmailBlock } from '../types';
import {
  TextProperties,
  ImageProperties,
  ButtonProperties,
  DividerProperties,
  SpacerProperties,
  SocialProperties,
  HtmlProperties,
  LayoutProperties,
  HeaderProperties,
  FooterProperties
} from './propertyEditors';

interface PropertiesPanelProps {
  block: EmailBlock;
  onUpdate: (updates: Partial<EmailBlock>) => void;
  mergeTags?: Array<{ name: string; value: string; sample: string }>;
  isDarkMode: boolean;
}

export const PropertiesPanel: React.FC<PropertiesPanelProps> = ({
  block,
  onUpdate,
  mergeTags,
  isDarkMode
}) => {
  const handleContentUpdate = (contentUpdates: any) => {
    onUpdate({
      content: {
        ...block.content,
        ...contentUpdates
      }
    });
  };

  const handleStyleUpdate = (styleUpdates: React.CSSProperties) => {
    onUpdate({
      styles: {
        ...block.styles,
        ...styleUpdates
      }
    });
  };

  const commonProps = {
    block,
    onUpdate: handleContentUpdate,
    mergeTags,
    isDarkMode
  };

  return (
    <div className="h-full flex flex-col">
      <div className="p-4 border-b border-gray-200 dark:border-gray-700">
        <h3 className="text-sm font-semibold text-gray-900 dark:text-white">
          Properties
        </h3>
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 capitalize">
          {block.type} Block
        </p>
      </div>

      <div className="flex-1 overflow-y-auto p-4">
        {block.type === 'text' && <TextProperties {...commonProps} />}
        {block.type === 'image' && <ImageProperties {...commonProps} />}
        {block.type === 'button' && <ButtonProperties {...commonProps} />}
        {block.type === 'divider' && <DividerProperties {...commonProps} />}
        {block.type === 'spacer' && <SpacerProperties {...commonProps} />}
        {block.type === 'social' && <SocialProperties {...commonProps} />}
        {block.type === 'html' && <HtmlProperties {...commonProps} />}
        {block.type === 'header' && <HeaderProperties {...commonProps} />}
        {block.type === 'footer' && <FooterProperties {...commonProps} />}
        {(block.type === 'row' || block.type === 'column') && (
          <LayoutProperties {...commonProps} />
        )}
      </div>
    </div>
  );
};
